import React from 'react';
import { Grid, TextField } from '@mui/material';
import FormDialog from '../../common/FormDialog';

const ConductRatingFormDialog = ({ open, onClose, onSubmit, editingRating, formData, setFormData, saving, isMobile = false, existingRatings = [] }) => {
  const isDuplicateValue = formData.rating_value !== '' &&
    existingRatings.some((r) =>
      Number(r.rating_value) === Number(formData.rating_value) &&
      r.id !== editingRating?.id
    );

  return (
  <FormDialog open={open} onClose={onClose} onSubmit={onSubmit}
    title={editingRating ? 'Edit Conduct Rating' : 'Add Conduct Rating'}
    saving={saving} isMobile={isMobile} maxWidth="sm" disabled={isDuplicateValue}>
    <Grid container spacing={2} sx={{ pt: 1 }}>
      <Grid item xs={12} sm={6}>
        <TextField fullWidth label="Rating Code" value={formData.rating_code}
          onChange={(e) => setFormData({ ...formData, rating_code: e.target.value.toUpperCase() })}
          placeholder="e.g. EXC" helperText="Auto-generated from name if left blank" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField fullWidth label="Value" type="number" value={formData.rating_value}
          onChange={(e) => setFormData({ ...formData, rating_value: e.target.value })}
          placeholder="e.g. 5" required inputProps={{ min: 1 }}
          error={isDuplicateValue}
          helperText={isDuplicateValue ? `Value ${formData.rating_value} is already used by another rating` : 'Must be unique across all ratings'} />
      </Grid>
      <Grid item xs={12}>
        <TextField fullWidth label="Rating Name" value={formData.rating_name}
          onChange={(e) => setFormData({ ...formData, rating_name: e.target.value })}
          placeholder="e.g. Excellent, Good, Fair, Poor" required />
      </Grid>
      <Grid item xs={12}>
        <TextField fullWidth multiline rows={3} label="Description" value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          placeholder="e.g. Student demonstrates outstanding conduct" />
      </Grid>
    </Grid>
  </FormDialog>
  );
};

export default ConductRatingFormDialog;
